import React from 'react';
import Image from '@ecs/tng-common/src/components/image/Image';
import Modal from 'react-bootstrap/Modal';
import TooltipExp from '@ecs/tng-common/src/components/tooltip/TooltipExp';
// copy
import { howWeMatch } from '@ecs/tng-common/src/documents/disclosures/cm-disclosures';
// scripts
import { formCTAurl, SigninRefPath } from '@ecs/tng-common/src/scripts/registration';
import { UiLog, EventName, postUiLog } from '@ecs/tng-common/src/scripts/uilog';
import { addApostropheS, useThrottle } from '@ecs/tng-common/src/scripts/helpers';
import { ICard } from '../interfaces/cards';

export type ApplyCardsModalProps = {
  show: boolean;
  onHide?: () => void;
  card: ICard;
  className?: string;
  analyticsPlacement: string;
  index?: number;
};
class ApplyCardsModal extends React.Component<ApplyCardsModalProps> {
  private uiLog = new UiLog();

  componentDidMount() {
    if (typeof window !== 'undefined' && window.opAppend) {
      window.opAppend();
    }
    postUiLog(EventName.modalDisplay, {
      offers: this.props.card.offerId,
      lgcategory: 'credit',
      placement: this.props.analyticsPlacement,
      category: 'rightoffer-speedbump-apply'
    });
  }

  ctaClick() {
    postUiLog(EventName.trackLink, {
      identifier: `lg-rightoffer-speedbump-rank-${this.props.index}`,
      placement: 'rightoffer-modalapplyonsite',
      lgplacement: `${this.props.analyticsPlacement}`,
      lgcategory: 'cards',
      lgoffer: `${this.props.card.offerId}:${this.props.card.offerName}`,
      offersource: 'rightoffer',
      lgrank: '0',
      lgrequestid: '',
      offertraits: this.uiLog.returnOfferTraits([this.props.card.offerId]),
      type: 'e'
    });
    const url = new URL(this.props.card.link);
    const params = new URLSearchParams(url.search);
    const newParams: any = this.uiLog.getRedirectLinkParams({
      placement: this.props.analyticsPlacement
    });
    Object.keys(newParams).forEach((key) => params.append(key, newParams[key]));
    url.search = params.toString();

    window.location.href = url.toString();
  }

  modalClose() {
    postUiLog(EventName.trackLink, {
      identifier: `marketplace-pl-speedbump-${this.props.card.offerId}-close`,
      type: 'o',
      placement: `${this.props.analyticsPlacement}-speedbump`
    });
  }

  render() {
    const formRegistrationParams = () => {
      const obj = {
        offer: 'at_frsas109',
        authType: '102',
        refUrl: SigninRefPath.creditCards,
        tgt_ro: this.props.card.offerId
      };
      return obj;
    };
    return (
      <Modal
        aria-labelledby="dialog-title"
        show={this.props.show}
        onHide={this.props.onHide}
        fullscreen="sm-down"
        className={`text-center ${this.props.className || ''}`}>
        <Modal.Header
          closeButton
          onHide={() => this.modalClose()}
        />

        <Modal.Body>
          <Image
            className="mb-4 d-block mx-auto"
            alt={`${this.props.card.offerName} logo.`}
            src={this.props.card.imageDownloaded}
            width="190"
            height="118"
            lazyLoading
          />
          <h3 id="dialog-title">Take the guesswork out of applying for this offer</h3>
          <p className="mb-4 text-gray">
            See offers matched for you instantly. Create a free Experian account now to see your
            offers.
          </p>
          <p className="text-gray mb-5">
            How we match you
            <TooltipExp
              id="modal-match"
              body={howWeMatch}>
              <button
                type="button"
                className="btn btn-link ecs-font-icon-act-info ms-2 font-icon-size-md"
                aria-label="Learn more tooltip."
              />
            </TooltipExp>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <a
            className="btn btn-primary"
            href={formCTAurl(formRegistrationParams())}
            data-op="LRL">
            Get started for free
          </a>
          {this.props.card.provider && (
            <button
              type="button"
              className="btn btn-link text-decoration-underline modal-footer-addon"
              onClick={() => {
                useThrottle(this.ctaClick());
              }}>
              No thanks, I’ll apply now on {addApostropheS(this.props.card.provider)} website.
            </button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ApplyCardsModal;
